// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1EzlM","amount":"Amount_amount__WG5tX","tip":"Amount_tip__30wyR","tipHeader":"Amount_tipHeader__1J0MW","tipsWrap":"Amount_tipsWrap__3RHEz"};